import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ImageModule } from 'primeng/image';
import { ApplicationService } from '../../services/application.service';

@Component({
  selector: 'app-financial-gestor',
  standalone: true,
  imports: [ImageModule, CommonModule,RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './financial-gestor.component.html',
  styleUrl: './financial-gestor.component.scss'
})
export class FinancialGestorComponent implements OnInit{

  menuItems = [
    {
      title: 'Eventos',
      description:'Gestión de pagos y recibos de los eventos',
      class: 'pi pi-calendar text-4xl text-green-500',
      routerLink: 'events',
    },
    {
      title: 'Vinculaciones',
      description:'Gestión de pagos y recibos de las vinculaciones',
      class: 'pi pi-users text-4xl text-green-500',
      routerLink: 'vinculaciones',
    }
  ];

  constructor(private applicationService:ApplicationService) { 


  } 

  ngOnInit(): void {
    
  }


}
